import React from 'react'
import style from "../layout.module.css"
import { MainHeader } from '../../components';

export function HeadBarLayout(props: { children: React.ReactNode }): React.ReactElement {
    const { children } = props;
    return (
        <div className={style.headBarLayoutContainer}>
            <MainHeader />
            <main id='main' className={style.mainContentContainer}>{children}</main>
        </div>
    )
}